<template>
  <div class="row">
    <div class="col-12">
      <b-card header="<i class='fa fa-file-o'></i> My Dashboard"></b-card>
    </div>
    <b-modal title="Informasi!!" v-model="modalInformasi" hide-footer>
      <p>berdasarkan PER-6/PJ/2024 maka per tanggal 01 Januari 2024 diberlakukan ketentuan NPWP 16 digit. Diharapkan anda dapat mengganti NPWP anda secara mandiri dengan cara sebagai berikut:</p>
      <p>1. Klik Akun anda di pojok kanan atas halaman web ini</p>
      <p>2. Klik profile</p>
      <p>3. Pastikan data yang ditampilkan sesuai</p>
      <p>4. Klik Ubah NPWP</p>
      <p>5. Masukkan NPWP 16 digit anda</p>
      <p>6. Klik Simpan</p>
      <router-link :to="'/profile'" class="btn btn-primary pull-right">Ke Profil <i class="fa fa-arrow"></i> </router-link>
    </b-modal>
  </div>
</template>
<script>
export default {
  data () {
    return {
      modalInformasi: true
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/Dashboard.vue?038d9394